import { onFreshResponse } from '../capacitor/offlineCache';
import { getTreeSuccess } from './actions/treeActions/getTree';
import { userGetListSuccess } from './actions/usersActions/usersGetList';
import { getTagNodesSuccess } from './actions/tagsActions/getTagNodes';
import { internationalizationAPI } from '../main/platform/ducks/translations';
import { measurementsV3API } from '../main/platform/dashboards/analysis/ducks';
import { modelAPI } from '../main/platform/ducks/model';
import type { AppDispatch } from './hooks';

// RootState does not list the API slices, so their util thunks are cast, as elsewhere in the app.
/** The startup data served from the cache first, and how its fresh copy reaches the store. */
export const registerOfflineRevalidation = (dispatch: AppDispatch): void => {
    onFreshResponse(/\/api\/model\/tree\/\?max_depth=MACHINE$/, (data) =>
        dispatch(getTreeSuccess((data as { data: unknown }).data, null, true)),
    );
    onFreshResponse(/\/api\/login\/user\/$/, (data) => dispatch(userGetListSuccess(data)));
    onFreshResponse(/\/api\/tag\/node_tags\/\?/, (data, url) =>
        dispatch(
            getTagNodesSuccess(
                data as Parameters<typeof getTagNodesSuccess>[0],
                new URL(url).searchParams.getAll('name[]'),
            ),
        ),
    );
    onFreshResponse(/\/api\/translations\/$/, (data) =>
        dispatch(internationalizationAPI.util.upsertQueryData('getTranslations', undefined, data) as any),
    );
    onFreshResponse(/\/api\/model\/v3\/measurements\/global_metadata\/$/, (data) =>
        dispatch(measurementsV3API.util.upsertQueryData('getGlobalMetadata', undefined, data) as any),
    );
    onFreshResponse(/\/api\/model\/node\/schema\/$/, (data) =>
        dispatch(modelAPI.util.upsertQueryData('getNodeSchema', undefined, data) as any),
    );
};
